import {
  CLEAR_ASSET_DATA,
  CLEAR_ASSET_FOR_LABEL_DATA,
  CREATE_ASSET_SUCCESS,
  FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS,
  FETCH_ASSET_FOR_LABEL_SUCCESS,
  FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS,
  FETCH_ASSET_REPORT_DATA_SUCCESS,
  FETCH_ASSET_SUCCESS,
  FETCH_BOWSER_DATA_SUCCESS,
  GET_ALL_ASSET_TYPE_SUCCESS,
  GET_ALL_ASSETS_START,
  GET_ALL_ASSETS_SUCCESS,
  GET_ASSET_FROM_CODE_SUCCESS,
  GET_ASSET_FROM_QR_SUCCESS,
  GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS,
  GET_ASSET_SUCCESS,
  GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS,
  GET_IDEAL_ASSET_COUNT_START,
  GET_IDEAL_ASSET_COUNT_SUCCESS,
  GET_MODEL_BY_ASSET_MAKES_SUCCESS,
  MAKE_ASSET_LEASABLE,
  SAVE_ASSET_QUERY,
  GET_ASSET_LAST_IMAGE_SUCCESS,
  GET_ASSET_IMAGES_SUCCESS,
  GET_ASSET_DEVICE_LAST_DATA_SUCCESS,
  GET_ASSET_DEVICE_RANGE_DATA_SUCCESS,
  GET_TAGGED_DEVICE_DATA_SUCCESS,
  GET_ASSET_DEVICE_FUEL_DATA_SUCCESS,
  FETCH_DEVICE_FUEL_START, FETCH_DEVICE_FUEL_END,
  FETCH_DEVICE_DAILY_FUEL_START,
  FETCH_DEVICE_DAILY_FUEL_END,
  GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS, GET_RECONCILIATION_ASSETS_SUCCESS,
  PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetCode: "",
  assetTypes: [],
  equipmentSubTypes: [],
  assetModels: [],
  reports: [],
  historyReport: {},
  labelData: {},
  assetModel: "",
  bowsers: [],
  leasable: 0,
  allAssetsLoading: false,
  allAssets: [],
  allAssetsGroup: null,
  idealAssetCount: 0,
  idealAssetCountLoading: false,
  assetFromQr: null,
  assetFromCode: null,
  assetLastImage: {},
  assetImages: {},
  assetDeviceRangeData: [],
  assetDeviceLastData: null,
  assetDeviceFuelData: null,
  taggedDevices: [],
  deviceFuelLoading: false,
  assetDeviceDailyFuelData: [],
  deviceDailyFuelDataLoading: false,
  assetsForReconciliation: [],
  assetDeviceDailyFuelDataSuccess: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_QUERY: {
      return {
        ...state,
        query: action.query
      };
    }

    case GET_ASSET_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total
      };
    }

    case CREATE_ASSET_SUCCESS: {
      return {
        ...state,
        resource: action.data
      };
    }

    case FETCH_ASSET_SUCCESS: {
      return {
        ...state,
        edit: action.data,
        assetModel: action.data.assetModelData ? action.data.assetModelData : ""
      };
    }

    case FETCH_ASSET_FOR_LABEL_SUCCESS: {
      return {
        ...state,
        labelData: action.data
      };
    }

    case GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS: {
      return {
        ...state,
        assetModel: action.data
      };
    }

    case FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS: {
      return {
        ...state,
        assetCode: action.data
      };
    }

    case GET_ALL_ASSET_TYPE_SUCCESS: {
      return {
        ...state,
        assetTypes: action.data
      };
    }

    case GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS: {
      return {
        ...state,
        equipmentSubTypes: action.data
      };
    }

    case GET_MODEL_BY_ASSET_MAKES_SUCCESS: {
      return {
        ...state,
        assetModels: action.data
      };
    }

    case FETCH_ASSET_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        reports: action.data
      };
    }

    case FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        historyReport: action.data
      };
    }

    case CLEAR_ASSET_DATA: {
      return {
        ...state,
        edit: {}
      };
    }

    case CLEAR_ASSET_FOR_LABEL_DATA: {
      return {
        ...state,
        labelData: {}
      };
    }

    case FETCH_BOWSER_DATA_SUCCESS: {
      return {
        ...state,
        bowsers: action.data
      };
    }

    case MAKE_ASSET_LEASABLE: {
      return {
        ...state,
        leasable: action.data
      };
    }

    case GET_ALL_ASSETS_START: {
      return {
        ...state,
        allAssetsLoading: true
      };
    }

    case GET_ALL_ASSETS_SUCCESS: {
      return {
        ...state,
        allAssetsLoading: false,
        allAssets: action.data,
        allAssetsGroup: action.group,
      };
    }

    case GET_IDEAL_ASSET_COUNT_SUCCESS: {
      return {
        ...state,
        idealAssetCount: action.count,
        idealAssetCountLoading: false
      }
    }
    case GET_IDEAL_ASSET_COUNT_START: {
      return {
        ...state,
        idealAssetCountLoading: true
      };
    }
    case GET_ASSET_FROM_QR_SUCCESS: {
      return {
        ...state,
        assetFromQr: action.data
      };
    }
    case GET_ASSET_FROM_CODE_SUCCESS: {
      return {
        ...state,
        assetFromCode: action.data
      };
    }
    case GET_ASSET_LAST_IMAGE_SUCCESS: {
      return {
        ...state,
        assetLastImage: { ...state.assetLastImage, ...{ [action.data.asset]: action.data.images } }
      };
    }
    case GET_ASSET_IMAGES_SUCCESS: {
      return {
        ...state,
        assetImages: { ...state.assetImages, ...{ [action.data.asset]: action.data.images } }
      };
    }

    case GET_ASSET_DEVICE_LAST_DATA_SUCCESS: {
      return {
        ...state,
        assetDeviceLastData: { ...state.assetDeviceLastData, ...{ [action.data.device]: action.data.data } }
      };
    }

    case GET_ASSET_DEVICE_FUEL_DATA_SUCCESS: {
      return {
        ...state,
        assetDeviceFuelData: { ...state.assetDeviceFuelData, ...{ [action.data.device]: action.data.data } }
      };
    }

    case GET_ASSET_DEVICE_RANGE_DATA_SUCCESS: {
      return {
        ...state,
        assetDeviceRangeData: action.data
      };
    }

    case GET_TAGGED_DEVICE_DATA_SUCCESS: {
      return {
        ...state,
        taggedDevices: action.data
      };
    }

    case FETCH_DEVICE_FUEL_START: {
      return {
        ...state,
        deviceFuelLoading: true
      };
    }

    case FETCH_DEVICE_FUEL_END: {
      return {
        ...state,
        deviceFuelLoading: false
      };
    }

    case GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS: {
      return {
        ...state,
        assetDeviceDailyFuelData: action.data
      };
    }

    case FETCH_DEVICE_DAILY_FUEL_START: {
      return {
        ...state,
        deviceDailyFuelDataLoading: true
      };
    }

    case FETCH_DEVICE_DAILY_FUEL_END: {
      return {
        ...state,
        deviceDailyFuelDataLoading: false
      };
    }

    case GET_RECONCILIATION_ASSETS_SUCCESS: {
      return {
        ...state,
        assetsForReconciliation: action.data
      };
    }

    case PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS: {
      console.log('action=>', action);
      return {
        ...state,
        assetDeviceDailyFuelDataSuccess: !!action.data
      };
    }

    default:
      return state;
  }
};
